import { defineStore } from 'pinia'
import type { Emitter, EventType, Handler } from 'mitt'
import mitt from 'mitt'
import type { EventPayload } from '@/store/modules/event/types'

const useEvenStore = defineStore('eventBus', () => {
  const emitter: Emitter<Record<EventType, unknown>> = mitt()

  function on<T>(event: EventType, handler: Handler<T>) {
    emitter.on(event, handler as Handler<unknown>)
  }

  function off<T>(event: EventType, handler: Handler<T>) {
    emitter.off(event, handler as Handler<unknown>)
  }

  function emit(event: EventType, payload?: EventPayload) {
    emitter.emit(event, payload)
  }

  function clear() {
    emitter.all.clear()
  }

  function all() {
    return emitter.all
  }

  return {
    on,
    off,
    emit,
    clear,
    all,
  }
})

export default useEvenStore
